<template>
    <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            locale="de"
            multi-sort
            no-data-text="Es liegen noch keine Daten vor."
            no-results-text="Es wurden keine Ergebnisse gefunden."
            loading-text="Lädt..."
            :footer-props="{
                            itemsPerPageText: 'Einträge pro Seite',
                            itemsPerPageOptions: [10,25,50,100, -1],
                            itemsPerPageAllText: 'Alle'
                        }"

    >
        <template v-slot:item.action="{ item }">
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs}">
                    <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            icon
                            :to="{ name: 'EmployeeInterviewsEdit', params: { id: item.interview_id }, query: {type: 'hr-department'}, hash:'#advancements'}"
                            exact
                    >
                        <v-icon>mdi-eye</v-icon>
                    </v-btn>
                </template>
                <span>Ansicht</span>
            </v-tooltip>
        </template>

        <template v-slot:item.actions_type="{ item }">
            <span v-if="item.actions_type === 'seminar'">Seminar</span>
            <span v-if="item.actions_type === 'coaching'">Coaching</span>
            <span v-if="item.actions_type === 'literature'">Literatur</span>
            <span v-if="item.actions_type === 'other'">Sonstiges</span>
        </template>

        <template v-slot:item.actions_responsible="{ item }">
            <span v-if="item.actions_responsible === 'employee'">Mitarbeiter</span>
            <span v-if="item.actions_responsible === 'executive'">Führungskraft</span>
            <span v-if="item.actions_responsible === 'hr'">Personalabteilung</span>
        </template>
    </v-data-table>
</template>

<script>
    export default {
        props: ['headers', 'search', 'items'],
    }
</script>

<style scoped>

</style>